import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Vibeu from '../images/vibeu-logo.png';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="glass-nav px-4 py-3">
            <div className="container flex justify-between items-center mx-auto max-w-6xl">
                <Link to="/" aria-label="Back to top" className="flex items-center">
                    <img src={Vibeu} className="h-10" alt="vibeu logo" />
                </Link>

                <ul
                    className="hidden md:flex items-center space-x-8 text-sm tracking-wider uppercase"
                    style={{ color: 'rgba(255,255,255,0.62)' }}
                >
                    {['About', 'Projects', 'Blog'].map((label) => (
                        <li key={label}>
                            <a
                                href={`#${label.toLowerCase()}`}
                                className="hover:text-orange-400 transition-colors duration-200"
                            >
                                {label}
                            </a>
                        </li>
                    ))}
                    <li>
                        <a
                            href="https://github.com/Vybeu"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="glass-btn !py-2 !px-4 cursor-pointer"
                        >
                            GitHub
                        </a>
                    </li>
                </ul>

                <button
                    className="md:hidden focus:outline-none cursor-pointer"
                    style={{ color: 'rgba(255,255,255,0.65)' }}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {menuOpen
                            ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
                            : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />
                        }
                    </svg>
                </button>
            </div>

            {menuOpen && (
                <div
                    className="md:hidden mt-2 pb-4"
                    style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
                >
                    <ul
                        className="flex flex-col space-y-4 pt-4 text-sm tracking-wider uppercase px-4"
                        style={{ color: 'rgba(255,255,255,0.6)' }}
                    >
                        {['About', 'Projects', 'Blog'].map((label) => (
                            <li key={label}>
                                <a
                                    href={`#${label.toLowerCase()}`}
                                    onClick={() => setMenuOpen(false)}
                                    className="hover:text-orange-400 transition-colors"
                                >
                                    {label}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a
                                href="https://github.com/Vybeu"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-orange-400 hover:text-orange-300 transition-colors"
                            >
                                GitHub &rarr;
                            </a>
                        </li>
                    </ul>
                </div>
            )}
        </header>
    );
};

export default Navbar;
